import apiClient from '../apiClient';

// Todo API calls

export const getTodos = () => {
  return apiClient.get('/api/todos');
};

export const createTodo = (todoData) => {
  return apiClient.post('/api/todos', todoData);
};

export const updateTodo = (todoId, todoData) => {
  return apiClient.put('/api/todos/' + todoId + '/status', todoData);
};

export const deleteTodo = (todoId) => {
  return apiClient.delete('/api/todos/' + todoId);
};
